window.addEventListener('DOMContentLoaded', function () {
  const subscribeKlaviyoList = (form, klaviyoCompanyId, klaviyoListId) => {
    const isSubscribed = !!form['email_marketing_consent']
    const userAttributes = {
      email: form['email'],
      first_name: form['first_name'],
      last_name: form['last_name'],
      properties: {
        'default_address.province': form['default_address.province'],
        primary_place_of_work: form['primary_place_of_work'],
        service_focus: form['service_focus'],
        favorite_hair_brands: form['favorite_hair_brands'],
        $source: 'Approved Pro Account',
      },
    }

    const payload = {
      type: isSubscribed ? 'subscription' : 'profile',
      attributes: isSubscribed
        ? {
            custom_source: 'Approved Pro Account',
            profile: {
              data: {
                type: 'profile',
                attributes: userAttributes,
              },
            },
          }
        : userAttributes,
    }

    if (isSubscribed)
      payload['relationships'] = {
        list: { data: { type: 'list', id: klaviyoListId } },
      }

    const options = {
      method: 'POST',
      headers: { revision: '2023-12-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: payload,
      }),
    }

    const url = `https://a.klaviyo.com/client/${
      isSubscribed ? 'subscriptions' : 'profiles'
    }/?company_id=${klaviyoCompanyId}`

    fetch(url, options)
  }

  const handleCF = () => {
    if (window.CF.appEmbedEnabled) {
      const section = document.querySelector('.js-section-vip-signup')
      setTimeout(() => {
        const inputs = section.querySelectorAll('input')
        inputs.forEach((input) => {
          input.addEventListener('focusin', () => {
            const label = input.previousElementSibling
            label && label.classList.add('section-vip-signup__label--focus')
          })
          input.addEventListener('focusout', (e) => {
            const label = input.previousElementSibling
            const value = e.target.value
            if (!value && label) {
              label.classList.remove('section-vip-signup__label--focus')
            }
          })
          input.addEventListener('input', (e) => {
            const value = e.target.value
            const label = input.previousElementSibling
            if (!!label) {
              label.classList[!value ? remove : add](
                'section-vip-signup__label--filled'
              )
            }
          })
        })

        const arrows = section.querySelectorAll('.cf-down-arrow')
        arrows.forEach((arrow) => {
          arrow.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.4141 4.08334L6.9974 9.69793L0.580729 4.08334" stroke="#2B2829"/>
            </svg>`
        })
      }, 300)

      const form = section.querySelector('form')
      form.addEventListener('submit', (e) => {
        const formData = new FormData(form)

        const formJson = {}
        formData.forEach((value, key) => (formJson[key] = value))
        const { klaviyoCompanyId, klaviyoListId } = section.dataset
        subscribeKlaviyoList(formJson, klaviyoCompanyId, klaviyoListId)
      })

      clearInterval(cfInerval)
    }
  }
  let cfInerval = setInterval(handleCF, 300)
  const targetClass = 'hh-submission-success'
  const hasTargetClass = (element) => {
    return element.classList.contains(targetClass)
  }
  const stopObserver = (observer) => {
    observer.disconnect()
  }
  // Mutation Observer setup
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      for (const addedNode of mutation.addedNodes) {
        if (
          addedNode.nodeType === Node.ELEMENT_NODE &&
          hasTargetClass(addedNode)
        ) {
          const section = document.querySelector('.js-section-vip-signup')
          section.classList.add('section-vip-signup--success')
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
          stopObserver(observer)
          break
        }
      }
    }
  })
  // Options for the Mutation Observer (observe the document's childList)
  const observerOptions = {
    childList: true,
    subtree: true,
  }
  // Start observing the document
  observer.observe(document, observerOptions)
})
